import React from "react"
import SbEditable from "storyblok-react"
import Components from "./components.js"
import { Form, transformLinkUri } from "gatsby-theme-gba"
import Markdown from "react-markdown"

const FormEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <Form
      formName={blok.formName}
      heading={blok.heading}
      subHeading={blok.subHeading}
      buttonText={blok.buttonText}
      successHeading={blok.successHeading}
      successMessage={
        <Markdown
          source={blok.successMessage}
          transformLinkUri={uri => {
            return transformLinkUri(
              uri,
              "",
              blok.currentLanguage,
              blok.seoLinks
            )
          }}
        />
      }
      successBtnText={blok.successBtnText}
    >
      {blok.formElements &&
        blok.formElements.map(blokItem =>
          React.createElement(Components(blokItem.component), {
            key: blokItem._uid,
            blok: {
              ...blokItem,
              seoLinks: blok.seoLinks,
              currentLanguage: blok.currentLanguage,
            },
          })
        )}
    </Form>
  </SbEditable>
)

export default FormEditable
